import { render, staticRenderFns } from "./RemoveModel.vue?vue&type=template&id=7bc474b2&scoped=true"
import script from "./RemoveModel.vue?vue&type=script&lang=js"
export * from "./RemoveModel.vue?vue&type=script&lang=js"
import style0 from "./RemoveModel.vue?vue&type=style&index=0&id=7bc474b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc474b2",
  null
  
)

export default component.exports